







































































































































import Component, { mixins } from "vue-class-component";
import BaseTable, {
  StringKeyObject,
  CallbackItemClass
} from "@/components/common/BaseTable.vue";
import { HeaderWidthItem } from "@/types";
import AxiosMixin from "../mixins/axiosMixin";
import { Ref } from "vue-property-decorator";
import { State, namespace } from "vuex-class";
import LoadingDialog from "@/components/common/LoadingDialog.vue";
import SelectFilter, {
  ColumnKey,
  FilterClause
} from "@/components/common/SelectFilter.vue";
import {
  YearmonthsState,
  SET_YEARMONTHS
} from "@/store/modules/yearmonths/types";

const StoreYearmonths = namespace("yearmonths");

@Component({
  components: {
    BaseTable,
    LoadingDialog,
    SelectFilter
  }
})
export default class MedicalReturn extends mixins(AxiosMixin) {
  @Ref("baseTable") private readonly baseTable!: BaseTable;
  @Ref("selectFilter")
  private readonly selectFilter!: SelectFilter;
  private readonly storageClausesKey: string =
    "MedicalTransmissionSearchClauses";

  @State("yearmonths") yearmonthsState!: YearmonthsState;
  @StoreYearmonths.Mutation(SET_YEARMONTHS) setYearmonths!: Function;
  private get storeReturnYearmonths() {
    return this.yearmonthsState.yearmonths;
  }
  private set storeReturnYearmonths(yearmonths: string[]) {
    localStorage.setItem("yearmonths", JSON.stringify(yearmonths));
    this.setYearmonths(yearmonths);
  }

  private headerItems: HeaderWidthItem[] = [
    {
      value: "yearmonth",
      text: "サービス提供年月",
      width: "108px"
    },
    {
      value: "is_exec",
      text: "処理済日",
      width: "140px"
    },
    {
      value: "ibow_id",
      text: "利用者ID",
      width: "98px",
      filter: (val: object) => this.columnFilter("ibow_id", val)
    },
    {
      value: "insured_no",
      text: "被保険者番号",
      width: "122px",
      filter: (val: object) => this.columnFilter("insured_no", val)
    },
    {
      value: "name",
      text: "氏名",
      width: "120px",
      filter: (val: object) => this.columnFilter("name", val)
    },
    {
      value: "furigana",
      text: "ﾌﾘｶﾞﾅ",
      width: "120px",
      filter: (val: object) => this.columnFilter("furigana", val)
    },
    {
      value: "return_reason",
      text: "返戻理由",
      width: "120px",
      filter: (val: object) => this.columnFilter("return_reason", val)
    },
    {
      value: "insurance_no",
      text: "保険者番号",
      width: "110px",
      filterType: SelectFilter.FILTER_TYPE_EDIT_LIST,
      filter: (val: object) => this.columnFilter("insurance_no", val)
    },
    {
      value: "insurance_name",
      text: "保険者名",
      width: "140px",
      filterType: SelectFilter.FILTER_TYPE_EDIT_LIST,
      filter: (val: object) => this.columnFilter("insurance_name", val)
    },
    {
      value: "import_datetime",
      text: "取込日時",
      width: "120px",
      filter: (val: object) => this.columnFilter("import_datetime", val)
    }
  ];

  //------------------------------------------
  // SelectFilterの選択肢
  //------------------------------------------
  private get columnKeys(): ColumnKey[] {
    return this.headerItems
      .filter(hditm => {
        return hditm.filter != null;
      })
      .map(hditm => {
        let type = SelectFilter.FILTER_TYPE_EDIT;
        if (hditm.filterType != null) {
          type = hditm.filterType;
        }
        let selectable = null;
        if (
          hditm.filterType === SelectFilter.FILTER_TYPE_LIST ||
          hditm.filterType === SelectFilter.FILTER_TYPE_EDIT_LIST
        ) {
          //選択肢一覧作成
          selectable = this.tableItems
            .map(itm => {
              const txt = (itm as any)[hditm.value];
              return txt === "" ? SelectFilter.NO_DATA : txt;
            })
            .filter((val, idx, arr) => {
              return arr.indexOf(val) === idx;
            });
          //NO_DATAラベルを一覧の先頭に移動
          const idx = selectable.indexOf(SelectFilter.NO_DATA);
          if (idx > 0) {
            this.moveAt(selectable, idx, 0);
          }
        }
        const fkey: ColumnKey = {
          type: type,
          key: hditm.value,
          text: hditm.text,
          selectable: selectable
        };
        return fkey;
      });
  }

  //------------------------------------------
  // カラムフィルター
  //------------------------------------------
  private columnFilter(key: string, val: object) {
    const bret = this.selectFilter.isMatch(key, val);

    // テーブル更新
    if (this.baseTable) {
      this.baseTable.handle();
    }
    return bret;
  }

  //------------------------------------------
  // 配列要素の移動
  //------------------------------------------
  private moveAt(array: object[], idx: number, at: number) {
    if (idx === at || idx > array.length - 1 || at > array.length - 1) {
      return;
    }
    const value = array[idx];
    const tail = array.slice(idx + 1);
    array.splice(idx);
    Array.prototype.push.apply(array, tail);
    array.splice(at, 0, value);
  }

  private tableItems: object[] = [];

  //結果ファイル取込ダイアログ
  private isFileSelectActive = false;
  //取込結果表示ダイアログ
  private resultDialog = false;
  //取込結果
  private resultMsg = "";
  //取込ファイル
  private fileCsv: Blob | null = null;

  //選択項目数
  private selectCount = 0;
  private onSelectChanged() {
    this.selectCount = this.baseTable.SelectedItems().length;
  }

  //-------------------------------
  // mounted()
  //-------------------------------
  mounted() {
    // 画面復帰設定（チェックボックス、フィルタ条件）
    if (!this.$route.query.st) {
      this.baseTable.clearAllCheck();
      this.selectFilter.clearAll();
    } else {
      this.baseTable.restoreStorage();
      this.selectFilter.restoreStorage();
    }
    // 画面更新
    this.updateData();
  }

  //-------------------------------
  // 返戻取得
  //-------------------------------
  private updateData() {
    this.fileCsv = null;

    this.postJsonCheck(
      window.base_url + "/api/office/medical/return/get",
      {},
      res => {
        this.tableItems = res.data.lists;
        this.$router.replace(`/medical/return?st=1`).catch(err => err);
        this.$nextTick(() => {
          this.baseTable.restoreStorage();
          this.baseTable.updateBaseTable();
        });
      }
    );
  }

  //-------------------------------
  // 検索
  //-------------------------------
  private search() {
    this.baseTable.clearAllCheck();
    this.updateData();
  }

  //---------------------------------------------
  //CSV取込
  //---------------------------------------------
  //CSV取込ダイアログ表示
  private openImportDialog() {
    this.isFileSelectActive = true;
  }
  private closeImportDialog() {
    this.isFileSelectActive = false;
    this.fileCsv = null;
  }
  //CSV取込ダイアログ閉じる
  private closeResultDialog() {
    this.resultDialog = false;
    this.updateData();
  }
  //取込処理
  private importResult() {
    if (!this.fileCsv) {
      alert("ファイルが選択されていません。");
      return;
    }
    if (!confirm("返戻ファイルを取り込みます。よろしいですか？")) {
      return;
    }
    const formData = new FormData();
    formData.append("uploadfile", this.fileCsv);
    this.postForm(
      window.base_url + "/api/office/medical/return/imp_csv",
      formData,
      response => {
        if (response.data.code != 0) {
          console.log("エラー401もここに入っている？", response);
          alert(response.data.message);
          return;
        }
        this.isFileSelectActive = false;
        this.resultMsg = response.data.message;
        this.resultDialog = true;
      }
    );
  }

  //---------------------------------------------
  //取込結果ダウンロード
  //---------------------------------------------
  private downloadResult() {
    const blob = new Blob([this.resultMsg]);
    const a = document.createElement("a");
    a.download = `取込結果_${this.dateFormat(new Date())}.txt`;
    a.href = URL.createObjectURL(blob);
    a.click();
  }

  //------------------------------------------
  // 返戻データ削除
  //------------------------------------------
  private get canDelete() {
    return this.selectCount > 0;
  }

  private deleteData() {
    const items = this.baseTable.SelectedItems();
    if (items.length == 0) return;

    if (!confirm("選択した返戻データの削除を行います。よろしいですか？")) {
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/office/medical/return/delete",
      {
        ids: items.map(item => item.id),
        patients: items.map(item => ({ id: item.patient_id, name: item.name }))
      },
      () => this.updateData()
    );
  }

  //-------------------------------
  // 日付フォーマット(yyyyMMdd_HHmmss)
  //-------------------------------
  private dateFormat(d: Date) {
    const ymd = `${d.getFullYear()}${(d.getMonth() + 1)
      .toString()
      .padStart(2, "0")}${d
      .getDate()
      .toString()
      .padStart(2, "0")}`;
    const hms = `${d
      .getHours()
      .toString()
      .padStart(2, "0")}${d
      .getMinutes()
      .toString()
      .padStart(2, "0")}${d
      .getSeconds()
      .toString()
      .padStart(2, "0")}`;
    return `${ymd}_${hms}`;
  }

  // 年月選択時の処理

  private selectYearmonth(yearmonth: string) {
    // 対象月の返戻を表示するための条件をセット
    this.storeReturnYearmonths = [yearmonth];
    sessionStorage.removeItem(this.storageClausesKey);
    const filterClauses: FilterClause = {
      id: 1,
      matchType: 1,
      menu: false,
      numIdx: 0,
      word: "返戻あり",
      colKey: { type: 1, text: "返戻", key: "return", selectable: [] }
    };
    sessionStorage.setItem(
      this.storageClausesKey,
      JSON.stringify([filterClauses])
    );
    this.$router.push({ path: "/medical/transmission?st=1" });
  }

  //日付のフォーマット YYYY-MM → YYYY年M月
  private formatYearmonth(val: string) {
    // 文字列が空か、フォーマットが正しくない場合は空文字を返す
    if (!val || !/^\d{4}-\d{2}$/.test(val)) return "";
    const [year, month] = val.split("-");
    // 月の部分が無効な場合（1～12以外）は空文字を返す
    const monthInt = parseInt(month, 10);
    if (monthInt < 1 || monthInt > 12) return "";
    return `${year}年${monthInt}月`;
  }

  //-----------------------------
  // 行の背景コールバック   complete返却で背景グレー
  //-----------------------------
  public itemClass: CallbackItemClass = (item: any) => {
    const isExec = (item as any).is_exec as string;
    if (isExec !== "") {
      return "complete";
    }
    return "";
  };
}
